export const columns: any[] = [
  {
    title: '车号',
    dataIndex: 'vehicleName',
    align: 'left',
  },
  {
    title: '事件',
    dataIndex: 'eventList',
    align: 'left',
  },
  {
    title: '工单编号',
    dataIndex: 'issueNumber',
    align: 'left',
  },
  {
    title: '工单持续时间',
    dataIndex: 'issueDuration',
    align: 'left',
  },
  {
    title: '工单创建时间',
    dataIndex: 'issueCreateTime',
    align: 'left',
  },
  {
    title: '工单状态',
    dataIndex: 'issueStatus',
    align: 'left',
  },
  {
    title: '听单人',
    dataIndex: 'acceptUsername',
    align: 'left',
  },
  {
    title: '操作',
    dataIndex: 'operations',
    align: 'left',
  },
];
